import {store} from './store';
import cookie from 'react-cookies';

export const AuthHeader = () => `Token ${cookie.loadAll().token || store.getState().loginAlerts.authToken}`;

const unsubscribe = store.subscribe(AuthHeader);
unsubscribe();
